export type SettingsTabRoute =
  | 'general-settings'
  | 'fees-and-payments'
  | 'outsourcing'
  | 'service-item'
  | 'cloud-computing'
  | 'cover-letter-templates'
  | 'connection';

export const tabRoutesMap = new Map<
  string,
  { index: number; label: string; path: SettingsTabRoute }
>([
  [
    'general-settings',
    { index: 0, label: 'General settings', path: 'general-settings' },
  ],
  [
    'fees-and-payments',
    { index: 1, label: 'Fees and payments', path: 'fees-and-payments' },
  ],
  ['outsourcing', { index: 2, label: 'Outsourcing', path: 'outsourcing' }],
  [
    'service-item',
    { index: 3, label: 'Service item editor', path: 'service-item' },
  ],
  [
    'cloud-computing',
    { index: 4, label: 'Use of cloud computing', path: 'cloud-computing' },
  ],
  [
    'cover-letter-templates',
    {
      index: 5,
      label: 'Cover letter templates',
      path: 'cover-letter-templates',
    },
  ],
]);

export const tabRoutesLabel = [...tabRoutesMap.entries()].map(
  ([path, { label }]) => ({ path, label }),
);
